import React from 'react'

//sub components
import SweepParticipantAndAccount from './SweepParticipantAndAccount';
import StandardSweepInstruction from './StandardSweepInstruction';
import OtherSweepInstructions from './OtherSweepInstructions';
import OtherSweepOptions from './OtherSweepOptions';
import CCRInterest from './CCRInterest';
import CCRBilateral from './CCRBilateral';

const SweepInstructionList = ({item,itemKey,glsAgent, pageJson, translations, translateWordForOption, accountCountryList, getCountryTaxonomy}) => {
  return (
    <div className="cc-sweep-instruction-wrapper" key={itemKey}>
      <div className="cc-sweep-instruction-wrapper_instruction">
        <div className="cc-sweep-instruction-wrapper_instruction__details-section">
          <label className="cc-sweep-instruction-wrapper_instruction__details-section__sweep-name">
            {`${item.sweepId}`}
            <span>
              {'ccrBilateralLimits' in item && item.ccrBilateralLimits.currency !== '' ? `(${item.ccrBilateralLimits.currency})` : ''}
            </span>
            <i className="icon icon-chevron-right"></i>
          </label>
          <p>{`${item.sweepParticipantsAccounts !== undefined ? item.sweepParticipantsAccounts.sweepType.name + ',' : ''} ${item.sweepParticipantsAccounts !== undefined && 'accountRegion' in  item.sweepParticipantsAccounts ? item.sweepParticipantsAccounts.accountRegion : ''}`}</p>
        </div>
        <div className="cc-sweep-instruction-wrapper_instruction__account-section">
          <label className="cc-sweep-instruction-wrapper_instruction__account-section__header">{pageJson.staticText_previewSweepInstruction !== undefined ? translations(pageJson.staticText_previewSweepInstruction.master) : 'Master'}</label>
          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__account-section__others"
          >
            {`${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.accountType !== undefined ? accountCountryList !== undefined
                ? getCountryTaxonomy(item.sweepParticipantsAccounts.masterAccountData).accountType.name+ ',' :item.sweepParticipantsAccounts.masterAccountData.accountType.name + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.accountNumber !== undefined ? item.sweepParticipantsAccounts.masterAccountData.accountNumber + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.branchCode !== undefined ? item.sweepParticipantsAccounts.masterAccountData.branchCode + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.country !== undefined ? accountCountryList !== undefined
                ? getCountryTaxonomy(item.sweepParticipantsAccounts.masterAccountData).country.name+ ',' :item.sweepParticipantsAccounts.masterAccountData.country.name + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.currency !== undefined ? item.sweepParticipantsAccounts.masterAccountData.currency.name : ''}`}
          </p>
          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__account-section__others"
          >
            {
              item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.accountHolder !== undefined
              ? item.sweepParticipantsAccounts.masterAccountData.accountHolder.name
              : ''
            }
          </p>
          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__country-section__others"
          >
            {item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.hsbcBankName !== undefined ? item.sweepParticipantsAccounts.masterAccountData.hsbcBankName.name : ''}
          </p>

          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__country-section__others"
          >
            {item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.bankName !== undefined ? item.sweepParticipantsAccounts.masterAccountData.bankName : ''}
          </p>

          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__country-section__others"
          >
            {item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.accountTitle !== undefined ? item.sweepParticipantsAccounts.masterAccountData.accountTitle : ''}
          </p>
          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__account-section__others"
          >
            {
              item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.masterAccountData !== undefined && item.sweepParticipantsAccounts.masterAccountData.tempRefrenceId !== undefined
              ? `(${item.sweepParticipantsAccounts.masterAccountData.tempRefrenceId})`
              : ''
            }
          </p>
        </div>
        <div className="cc-sweep-instruction-wrapper_instruction__country-section">
          <label className="cc-sweep-instruction-wrapper_instruction__country-section__header">{pageJson.staticText_previewSweepInstruction !== undefined ? translations(pageJson.staticText_previewSweepInstruction.sub) : 'Sub'}</label>
          <p style={{marginBottom: '0px'}} className="cc-sweep-instruction-wrapper_instruction__country-section__others">
            {`${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.accountType !== undefined ? accountCountryList !== undefined
                ? getCountryTaxonomy(item.sweepParticipantsAccounts.subAccountData).accountType.name+ ',' :item.sweepParticipantsAccounts.subAccountData.accountType.name + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.accountNumber !== undefined ? item.sweepParticipantsAccounts.subAccountData.accountNumber + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.branchCode !== undefined ? item.sweepParticipantsAccounts.subAccountData.branchCode + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.country !== undefined ?accountCountryList !== undefined
                ? getCountryTaxonomy(item.sweepParticipantsAccounts.subAccountData).country.name+ ',' :item.sweepParticipantsAccounts.subAccountData.country.name + ',' : ''}
              ${item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.currency !== undefined ? item.sweepParticipantsAccounts.subAccountData.currency.name : ''}`}
          </p>
          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__country-section__others"
          >
          {
            item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.accountHolder !== undefined
            ? item.sweepParticipantsAccounts.subAccountData.accountHolder.name
            : ''
          }
          </p>
          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__country-section__others"
          >
            {item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.hsbcBankName !== undefined ? item.sweepParticipantsAccounts.subAccountData.hsbcBankName.name : ''}
          </p>

          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__country-section__others"
          >
            {item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.bankName !== undefined ? item.sweepParticipantsAccounts.subAccountData.bankName : ''}
          </p>

          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__country-section__others"
          >
            {item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.accountTitle !== undefined ? item.sweepParticipantsAccounts.subAccountData.accountTitle : ''}
          </p>

          <p
            style={{marginBottom: '0px'}}
            className="cc-sweep-instruction-wrapper_instruction__account-section__others"
          >
            {
              item.sweepParticipantsAccounts !== undefined && item.sweepParticipantsAccounts.subAccountData !== undefined && item.sweepParticipantsAccounts.subAccountData.tempRefrenceId !== undefined
              ? `(${item.sweepParticipantsAccounts.subAccountData.tempRefrenceId})`
              : ''
            }
          </p>
        </div>
        <div className="cc-sweep-instruction-wrapper_instruction__status-section">
          <div className="cc-sweep-instruction-wrapper_instruction__status-section__status-text gdocs-float-left"></div>
        </div>
      </div>
      {
        'sweepParticipantsAccounts' in item && pageJson.staticText_previewSweepParticipantsAccounts !== undefined
        ? <SweepParticipantAndAccount
            item={item.sweepParticipantsAccounts}
            pageJson={pageJson.staticText_previewSweepParticipantsAccounts}
            translations={translations}
            translateWordForOption={translateWordForOption}
          />
        : ''
      }
      {
        'standardSweepInstructions' in item && pageJson.staticText_previewStandardSweepInstructions !== undefined
        ? <StandardSweepInstruction
            item={item.standardSweepInstructions}
            pageJson={pageJson.staticText_previewStandardSweepInstructions}
            translations={translations}
            translateWordForOption={translateWordForOption}
          />
        : ''
      }
      {
        'otherSweepInstructions' in item && 'sweepParticipantsAccounts' in item &&
          <OtherSweepInstructions
            item={item.otherSweepInstructions}
            pageJson={pageJson.staticText_otherSweepInstructionPanel}
            sweepParticipantsAccounts = {item.sweepParticipantsAccounts}
            translations={translations}
            translateWordForOption={translateWordForOption}
          />
      }
      {
        'otherSweepOptions' in item && pageJson.staticText_previewOtherSweepOptions !== undefined
        ? <OtherSweepOptions
            item={item.otherSweepOptions}
            pageJson={pageJson.staticText_previewOtherSweepOptions}
            sweepParticipantsAccounts = {item.sweepParticipantsAccounts}
            standardSweepInstructions = {item.standardSweepInstructions}
            translations={translations}
            translateWordForOption={translateWordForOption}
          />
        : ''
      }
      {
        'ccrInfo' in item &&
        <CCRInterest
          item={item.ccrInfo}
          pageJson={pageJson.staticText_ccrInterestPanel}
          translations={translations}
          translateWordForOption={translateWordForOption}
          account={item.sweepParticipantsAccounts}
        />
      }
      {
        'ccrBilateralLimits' in item && item.sweepParticipantsAccounts.bilateralLimits === true &&
        <CCRBilateral
          item={item.ccrBilateralLimits}
          pageJson={pageJson.staticText_bilateralLimitsPanel}
          translations={translations}
          translateWordForOption={translateWordForOption}
        />
      }

    </div>
  )
}

// Sweep Instruction
const SweepInstruction = (props) => {
  return (
    <div className="cc-sweep-instruction">
      <div className="cc-sweep-instruction__heading">{`2. ${props.translations(props.pageJson.staticText_previewSweepInstruction.pageHeading)}`}</div>
      {
        (props.data !== undefined && props.data.cashConcentration !== undefined && props.pageJson !== undefined) ? props.data.cashConcentration.sweepInstructions.map((item,key) =>
          <SweepInstructionList
            item={item}
            itemKey={key}
            glsAgent={props.data.glsAgent}
            pageJson={props.pageJson}
            translations={props.translations}
            translateWordForOption={props.translateWordForOption}
            accountCountryList= {props.accountCountryList}
            getCountryTaxonomy={(item) => props.getCountryTaxonomy(item)}
          />
        )
    :''  }
    </div>
  )
}

export default SweepInstruction;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/SweepInstruction/index.js